import React from 'react';

import InsertHtmlContent from 'components/Common/InsertHtmlContent/InsertHtmlContent';

type PropsType = React.HTMLAttributes<HTMLDivElement> & {
  htmlContent?: string;
};

export function HTMLZone({ htmlContent, ...rest }: PropsType): JSX.Element {
  return htmlContent ? (
    <InsertHtmlContent htmlContent={htmlContent} {...rest} />
  ) : (
    <div {...rest} />
  );
}
